module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-select",
    class: _vm.isSmall ? 'material-select--small' : ''
  }, [_c('div', {
    staticClass: "material-select__holder"
  }, [_c('div', {
    staticClass: "material-select__title",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v(_vm._s(_vm.showTitle) + " "), _c('div', {
    staticClass: "material-select__state",
    class: _vm.isOpen ? 'material-select__state--open' : ''
  })]), _vm._v(" "), (_vm.allowSearch) ? _c('div', {
    staticClass: "material-select__search",
    class: _vm.isOpen ? '' : 'hide'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "material-select__search-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "material-select__search__close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeSearchBox()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMulti) ? _c('div', {
    staticClass: "material-select__values",
    class: _vm.isOpen ? '' : 'hide'
  }, _vm._l((_vm.possibleValues), function(val) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedVariants),
        expression: "checkedVariants"
      }],
      staticClass: "material-select__checkbox",
      attrs: {
        "type": "checkbox",
        "id": val.id,
        "name": "selected-variant"
      },
      domProps: {
        "value": val.id,
        "checked": Array.isArray(_vm.checkedVariants) ? _vm._i(_vm.checkedVariants, val.id) > -1 : (_vm.checkedVariants)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedVariants,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedVariants = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedVariants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedVariants = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "material-select__label material-select__label--checkbox",
      attrs: {
        "for": val.id
      }
    }, [_vm._v(_vm._s(val.title))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isMulti) ? _c('div', {
    staticClass: "material-select__values",
    class: _vm.isOpen ? '' : 'hide'
  }, _vm._l((_vm.possibleValuesFiltered), function(val) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedVariants),
        expression: "checkedVariants"
      }],
      staticClass: "material-select__checkbox",
      attrs: {
        "type": "radio",
        "id": _vm.id + '_' + val.id,
        "name": "selected-variant"
      },
      domProps: {
        "value": val.id,
        "checked": _vm._q(_vm.checkedVariants, val.id)
      },
      on: {
        "change": function($event) {
          _vm.checkedVariants = val.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "material-select__label material-select__label--radio",
      attrs: {
        "for": _vm.id + '_' + val.id
      }
    }, [_vm._v(_vm._s(val.title))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isMulti) ? _c('div', {
    staticClass: "material-select__selected-values"
  }, _vm._l((_vm.checkedVariants), function(val) {
    return _c('div', {
      staticClass: "material-select__selected-value"
    }, [_vm._v("\n        " + _vm._s(_vm.possibleValuesMapped[val]) + "\n        "), _c('label', {
      attrs: {
        "for": val
      }
    }, [_vm._v("X")])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-488926d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/SelectMaterial.vue
// module id = 242
// module chunks = 1